<template>
  <div class="service detail wrap">
    <div class="text-bg maintenance">
      <div class="text-wrap">
        <p>{{ $t('service.detail.maintenance.lineText.01') }}</p>
        <p>{{ $t('service.detail.maintenance.lineText.02') }}</p>
        <p>{{ $t('service.detail.maintenance.lineText.03') }}</p>
      </div>
    </div>

    <!-- 타이틀 섹션 -->
    <HalfPageLayout class="maintenance title">
      <template #half-left>
        <div class="img maintenance"></div>
      </template>
      <template #half-right>
        <div class="inner-contents">
          <div class="contents-title">
            <h3 style="line-height: 1.1">
              {{ $t('service.title.maintenance') }}
            </h3>
            <h6>Operations & Maintenance</h6>
            <h4>{{ $t('service.detail.maintenance.subTitle') }}</h4>
          </div>
          <h5>{{ $t('service.detail.maintenance.desc') }}</h5>
        </div>
      </template>
    </HalfPageLayout>

    <!-- 운영 범위 및 유지관리 프로세스 -->
    <HalfPageLayout class="maintenance summary bg-light">
      <template #half-left>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('service.detail.maintenance.scope.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:wrench-thin" />
              <dl>
                <dt>{{ $t('service.detail.maintenance.firstPage.contents.01.title') }}</dt>
                <dd>{{ $t('service.detail.maintenance.firstPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:headset-thin" />
              <dl>
                <dt>{{ $t('service.detail.maintenance.firstPage.contents.02.title') }}</dt>
                <dd>{{ $t('service.detail.maintenance.firstPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:shield-warning-thin" />
              <dl>
                <dt>{{ $t('service.detail.maintenance.firstPage.contents.03.title') }}</dt>
                <dd>{{ $t('service.detail.maintenance.firstPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #half-right>
        <div class="img visual-01"></div>
      </template>
    </HalfPageLayout>

    <!-- 유지관리 프로세스 -->
    <HalfPageLayout class="maintenance summary bg-light">
      <template #half-left>
        <div class="img visual-02"></div>
      </template>
      <template #half-right>
        <div class="animation-bg">
          <div class="gear"><SvgGear /></div>
          <div class="gear"><SvgGear /></div>
        </div>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('service.detail.maintenance.process.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:arrows-clockwise-thin" />
              <dl>
                <dt>{{ $t('service.detail.maintenance.secondPage.contents.01.title') }}</dt>
                <dd>{{ $t('service.detail.maintenance.secondPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:chart-bar-thin" />
              <dl>
                <dt>{{ $t('service.detail.maintenance.secondPage.contents.02.title') }}</dt>
                <dd>{{ $t('service.detail.maintenance.secondPage.contents.02.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
    </HalfPageLayout>

    <!-- SLA / 대응 시간 -->
    <section class="section auto maintenance sla bg-light">
      <div class="sla-inner">
        <div class="section-title" data-aos="fade">
          <h3 class="hl">{{ $t('service.detail.maintenance.sla.title') }}</h3>
        </div>
        <div class="sla-table" data-aos="fade" data-aos-delay="300">
          <div
            v-for="(item, key) in $tm('service.detail.maintenance.sla.contents')"
            :key="key"
            class="sla-row"
          >
            <div class="sla-label">{{ item.label }}</div>
            <div class="sla-value">{{ item.value }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 도입 효과 -->
    <section class="section auto maintenance benefit">
      <h2 class="hl section-title">{{ $t('service.detail.maintenance.benefit.title') }}</h2>
      <div class="section-contents">
        <div class="benefit-grid inner-contents">
          <div
            v-for="(item, key) in $tm('service.detail.maintenance.benefit.contents')"
            :key="key"
            class="benefit-card"
            data-aos="fade-up"
          >
            <dt>{{ item.title }}</dt>
            <dd>{{ item.desc }}</dd>
          </div>
        </div>
        <router-link to="/contact" class="button big line">
          {{ $t('service.detail.contact') }}
        </router-link>
      </div>
    </section>

  </div>
</template>

<script>
import HalfPageLayout from '@/components/HalfPageLayout'
import { Icon } from '@iconify/vue'
import SvgGear from '@/components/SvgGear'

export default {
  name: 'ServiceDetailMaintenance',
  components: { SvgGear, HalfPageLayout, Icon }
}
</script>

<style scoped>
</style>
